import React from "react";
import PropTypes from "prop-types";

const RenderIf = (props) => <>{props.isTrue ? props.children : null}</>;

export default RenderIf;

// declare prop types
RenderIf.propTypes = {
  isTrue: PropTypes.bool.isRequired,
};
